import React, { useState } from 'react';
import { Form, Input, Button, Alert, Typography, Card, Space, Flex, Grid, theme } from 'antd';
import { UserOutlined, LockOutlined, EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import logoImage from '../../assets/2.png';
import Footer from '../Layout/Footer';
import versionData from '../../version.json';
import { palette } from '../../theme/palette';

const { Title, Text, Link } = Typography;
const { useBreakpoint } = Grid;

const UserLogin = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const screens = useBreakpoint();
  const { token } = theme.useToken();
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [form] = Form.useForm();

  const onFinish = async (values) => {
    setIsLoading(true);
    setError('');

    try {
      const success = await login(values);
      if (success) {
        navigate('/dashboard');
      } else {
        setError('Credenciales inválidas');
      }
    } catch (err) {
      setError('Error de conexión. Intenta nuevamente.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div
      style={{
        minHeight: '100vh',
        background: palette.userLoginGradient,
        display: 'flex',
        flexDirection: 'column',
        gap: '20px',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '20px',
      }}
    >
      {/* Efectos de fondo */}
      <div
        style={{
          position: 'absolute',
          top: '10%',
          left: '10%',
          width: screens.md ? '80px' : '40px',
          height: screens.md ? '80px' : '40px',
          backgroundColor: 'rgba(255,255,255,0.1)',
          borderRadius: '50%',
          animation: 'float 6s ease-in-out infinite',
        }}
      />
      <div
        style={{
          position: 'absolute',
          top: '70%',
          right: '15%',
          width: screens.md ? '60px' : '30px',
          height: screens.md ? '60px' : '30px',
          backgroundColor: 'rgba(255,255,255,0.1)',
          borderRadius: '50%',
          animation: 'float 4s ease-in-out infinite reverse',
        }}
      />
      
      {screens.md && (
        <img
          src={logoImage}
          alt="Logo"
          style={{
            maxWidth: '20%',
            height: 'auto'
          }}
        />
      )}

      <Card
        style={{
          width: '100%',
          maxWidth: '400px',
          borderRadius: '16px',
          boxShadow: '0 20px 40px rgba(0,0,0,0.1)',
          border: 'none',
          zIndex: 1,
        }}
      >
        <Flex vertical align="center" gap="large">
          <div style={{ textAlign: 'center' }}>
            <img
              src={logoImage}
              alt="Logo"
              style={{ width: '60px', height: 'auto', marginBottom: '16px' }}
            />
            <Title level={3} style={{ margin: 0, color: token.colorText }}>
              Bienvenido de nuevo
            </Title>
            <Text type="secondary">Inicia sesión para gestionar tus facturas (v{versionData.version})</Text>
          </div>

          {error && (
            <Alert
              message={error}
              type="error"
              showIcon
              style={{ width: '100%' }}
            />
          )}

          <Form
            form={form}
            name="login"
            onFinish={onFinish}
            layout="vertical"
            style={{ width: '100%' }}
            size="large"
          >
            <Form.Item
              label={<Text strong style={{ color: token.colorTextSecondary }}>Email:</Text>}
              name="email"
              rules={[{ required: true, message: 'El email es requerido' }]}
            >
              <Input
                prefix={<UserOutlined style={{ color: token.colorTextSecondary }} />}
                placeholder="Email"
                style={{
                  backgroundColor: token.colorBgLayout,
                  borderRadius: '8px',
                }}
              />
            </Form.Item>

            <Form.Item
              label={<Text strong style={{ color: token.colorTextSecondary }}>Contraseña:</Text>}
              name="password"
              rules={[{ required: true, message: 'La contraseña es requerida' }]}
            >
              <Input.Password
                prefix={<LockOutlined style={{ color: token.colorTextSecondary }} />}
                placeholder="Contraseña"
                iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
                style={{
                  backgroundColor: token.colorBgLayout,
                  borderRadius: '8px',
                }}
              />
            </Form.Item>

            <Form.Item style={{ marginBottom: 0 }}>
              <Button
                type="primary"
                htmlType="submit"
                loading={isLoading}
                block
                size="large"
                style={{
                  height: '48px',
                  borderRadius: '8px',
                  fontSize: '16px',
                  fontWeight: 600,
                }}
              >
                {isLoading ? 'Iniciando sesión...' : 'Iniciar Sesión'}
              </Button>
            </Form.Item>
          </Form>
        </Flex>
      </Card>
    </div>
  );
};

export default UserLogin;